"use client"
import { useEffect } from "react"
import { useRouter, usePathname } from "next/navigation"
import { useUser } from "@auth0/nextjs-auth0/client"
import { useUserProfile } from "@/hooks/useUserProfile"

export default function OnboardingGuard({
  lang,
  children,
}: {
  lang: string
  children: React.ReactNode
}) {
  const { user, isLoading } = useUser()
  const { data: profile, isLoading: profileLoading } = useUserProfile()
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    if (isLoading || profileLoading) return
    if (!user) return
    if (pathname?.includes("/onboarding")) return
    if (pathname?.includes("/activate")) return
    if (pathname?.replace(/\/+$/, "") === `/${lang}/select-account`) return
    if (profile && !profile.onboardingComplete) {
      router.push(`/${lang}/onboarding`)
    }
  }, [user, isLoading, profile, profileLoading, pathname, lang, router])

  return <>{children}</>
}
